// =============================================================================
// Language Selector - Selettore Lingua IT/EN
// =============================================================================

import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LANGUAGES = [
  { code: 'it', label: 'IT' },
  { code: 'en', label: 'EN' },
] as const;

export function LanguageSelector() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language?.substring(0, 2) ?? 'it';

  const handleChange = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  return (
    <div className="flex items-center gap-1">
      <Globe className="w-4 h-4 text-gray-400" />
      {LANGUAGES.map((lang) => (
        <button
          key={lang.code}
          onClick={() => handleChange(lang.code)}
          className={`px-1.5 py-0.5 text-xs font-medium rounded transition-colors ${
            currentLang === lang.code
              ? 'bg-emerald-100 text-emerald-700'
              : 'text-gray-400 hover:text-gray-600 hover:bg-gray-100'
          }`}
        >
          {lang.label}
        </button>
      ))}
    </div>
  );
}

export default LanguageSelector;
